import { WarrenModules } from '@/types/navigation';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

export interface Menu {
  label: string;
  feature?: FeatureFlags;
  module: Exclude<WarrenModules, WarrenModules.Home>;
}

export function getNavigation() {
  const menu: Menu[] = [
    {
      module: WarrenModules.Cash,
      label: 'Conta'
    },
    {
      module: WarrenModules.Wealth,
      label: 'Carteiras',
      feature: FeatureFlags.WEALTH_3_0
    },
    {
      module: WarrenModules.Trade,
      label: 'Bolsa',
      feature: FeatureFlags.TRADE_3_0
    }
  ];

  return menu.filter(
    item => !item.feature || FeatureFlagsModule.isEnabled(item.feature)
  );
}
